<template>
  <ForumDialog class="forum-next-delete-confirm" label="Eliminar mensaje" :request-close="close">
    <h2>¿Eliminar este mensaje?</h2>
    <p class="forum-next-meta">Mensaje #{{ post.number }} · {{ post.author.name }}</p>
    <p>Su contenido se sustituirá por un aviso de mensaje eliminado. La conversación y sus respuestas se conservan.</p>
    <p>No podrás recuperar el texto desde esta pantalla.</p>
    <p v-if="state.pending || state.checking" role="status">{{ state.checking ? 'Comprobando el estado del mensaje…' : 'Eliminando mensaje…' }}</p>
    <p v-else-if="state.error" role="alert">{{ state.error.message }}</p>
    <div class="forum-next-delete-confirm__actions">
      <button type="button" class="forum-next-button" :disabled="busy" @click="close">{{ state.error ? 'Cerrar' : 'Cancelar' }}</button>
      <button v-if="state.error" type="button" class="forum-next-button" :disabled="busy" @click="$emit('check')">Comprobar estado</button>
      <button v-else type="button" class="forum-next-button forum-next-delete-button" :disabled="busy" @click="$emit('confirm')">Eliminar mensaje</button>
    </div>
  </ForumDialog>
</template>
<script>
import ForumDialog from './ForumDialog.vue';
export default {
  name: 'ForumDeleteDialog', components: { ForumDialog },
  props: { post: { type: Object, required: true }, state: { type: Object, default: () => ({}) } },
  computed: { busy() { return Boolean(this.state.pending || this.state.checking); } },
  methods: { close() { if (!this.busy) this.$emit('close'); } }
};
</script>
